import { ExerciseCategoryDto } from '../../../../shared/dtos/exerciseCategory.dto';
import { ExerciseTagDto } from '../../../../shared/dtos/exerciseTag.dto';
import React, { FC, ReactElement } from 'react';
import Table from 'react-bootstrap/Table';
import i18next from 'i18next';
import { Button } from 'react-bootstrap';

type ExerciseTagsTableProps = {
  tags: ExerciseTagDto[];
  categories: ExerciseCategoryDto[];
  onClick?: (tag: ExerciseTagDto) => void;
}

const ExerciseTagTable: FC<ExerciseTagsTableProps> = ({ tags, categories, onClick }: ExerciseTagsTableProps): ReactElement => {

  return (
    <Table striped bordered hover responsive className="h-75 overflow-auto">
      <thead>
        <tr>
          <th className="centered-td">{i18next.t('exerciseTag.germanTitle')}</th>
          <th className="centered-td">{i18next.t('exerciseTag.englishTitle')}</th>
          <th className="centered-td">{i18next.t('exerciseTag.category')}</th>
          <th className="centered-td">{i18next.t('exerciseTag.isActive')}</th>
          {onClick !== undefined && (<th></th>)}
        </tr>
      </thead>
      <tbody>
        {tags.map((tag: ExerciseTagDto)=> (
          <tr key={tag.id}>
            <td className="centered-td">{tag.de}</td>
            <td className="centered-td">{tag.en}</td>
            <td className="centered-td">{categories.find(category => category.id === tag.categoryId)?.de}</td>
            <td className="centered-td">{i18next.t(tag.isActive ? 'exerciseTag.active' : 'exerciseTag.notActive')}</td>
            {onClick !== undefined && (
              <td className='centered-td'>
                <Button variant='dark' onClick={() => {onClick(tag);}}>
                  { i18next.t('generic.edit')}
                </Button>
              </td>
            )}
          </tr>
        ))}
      </tbody>
    </Table>
  );
};

export default ExerciseTagTable;
